import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { CheckpointAddButtonComponent } from './checkpoint-add-button/checkpoint-add-button.component';
import { CheckpointRemoveButtonComponent } from './checkpoint-remove-button/checkpoint-remove-button.component';
import { ChecklistEditCheckpointMenuComponent } from './checkpoint-menu/checkpoint-menu.component';
import { UtilitiesCommonModule } from '@fi-app/utilities/common/common.module';
import { ChecklistEditCheckpointSelectRoleToNotifyComponent } from './checkpoint-select-role-to-notify/checkpoint-select-role-to-notify.component';
import { ChecklistEditBtnAddSectionComponent } from './btn-add-section/btn-add-section.component';
import { ChecklistEditBtnChangePositionComponent } from './btn-change-position/btn-change-position.component';
import { CheckpointSelectRoleToNotifyDialogComponent } from './checkpoint-select-role-to-notify-dialog/checkpoint-select-role-to-notify-dialog.component';
import { ChecklistEditCheckpointNameComponent } from './checkpoint-name/checkpoint-name.component';
import { FormsModule } from '@angular/forms';
import { FiChecklistEditComponent } from './edit.component';
import { FiEditorPageModule } from '@fi-app/components/fi-editor-page/fi-editor-page.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiChecklistEditGeneralComponent } from './general/general.component';
import { FiEditNamesMatModule } from '@fi-app/components/fi-edit-names-mat/fi-edit-names-mat.module';
import { FiContenteditableSimpleTextPanelHandlerModule } from '@fi-app/components/fi-contenteditable-simple-text-panel-handler/fi-contenteditable-simple-text-panel-handler.module';
import { FiEditPublicationModule } from '@fi-shared/fi-edit-publication';
import { FiChecklistEditSettingsComponent } from './settings/settings.component';
import { FiPageCollapsableContentModule } from '@fi-app/components/fi-page-collapsable-content/fi-page-collapsable-content.module';
import { FiChecklistEditSharingSelectionComponent } from './sharing-selection/sharing-selection.component';
import { FiChecklistEditContentComponent } from './content/content.component';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiChecklistEditAddCheckpointConfirmComponent } from './add-checkpoint-confirm/add-checkpoint-confirm.component';
import { FiChecklistCommonModule } from '../common/fi-checklist-common.module';
import { FiQRCodeViewModule } from '@fi-shared/fi-qr-code-view/qr-code-view.module';
import { FiChecklistQRCodeDataListComponent } from './checklist-qr-code-data-list/checklist-qr-code-data-list.component';
import { FiCheckpointQRCodeViewComponent } from './checkpoint-qr-code-view/checkpoint-qr-code-view.component';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { CdkDrag, CdkDragHandle, CdkDropList } from '@angular/cdk/drag-drop';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatCardModule,
        MatCheckboxModule,
        MatRadioModule,
        UtilitiesCommonModule,
        MatDialogModule,
        MatInputModule,
        FormsModule,
        UtilitiesModule,
        FiValidatingFormModule,
        FiEditorPageModule,
        FiEditNamesMatModule,
        FiContenteditableSimpleTextPanelHandlerModule,
        FiEditPublicationModule,
        FiPageCollapsableContentModule,
        FiBindHtmlCompileModule,
        FiChecklistCommonModule,
        FiQRCodeViewModule,
        FiAttachmentsModule,
        SelectSearchModule,
        FiErrorMessageModule,
        CdkDropList,
        CdkDrag,
        CdkDragHandle,
    ],
    declarations: [
        FiChecklistEditComponent,
        FiChecklistEditGeneralComponent,
        CheckpointAddButtonComponent,
        CheckpointRemoveButtonComponent,
        ChecklistEditCheckpointMenuComponent,
        ChecklistEditCheckpointSelectRoleToNotifyComponent,
        ChecklistEditBtnAddSectionComponent,
        ChecklistEditBtnChangePositionComponent,
        CheckpointSelectRoleToNotifyDialogComponent,
        ChecklistEditCheckpointNameComponent,
        FiChecklistEditSettingsComponent,
        FiChecklistEditSharingSelectionComponent,
        FiChecklistEditContentComponent,
        FiChecklistEditAddCheckpointConfirmComponent,
        FiChecklistQRCodeDataListComponent,
        FiCheckpointQRCodeViewComponent,
    ],
    exports: [FiChecklistEditContentComponent],
})
export class ChecklistEditModule {}
